import {
  defaultCountdownUnits,
  urgencyCountdownThresholdMs,
} from './constants';
import type { CountdownUnit } from './types';

export function formatDeadline(
  endDate: string,
  locale = 'en-SG',
  includeYear = true,
): string {
  const date = new Date(endDate);
  if (Number.isNaN(date.getTime())) return '';

  const options: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'short',
    ...(includeYear ? { year: 'numeric' } : {}),
  };

  try {
    return new Intl.DateTimeFormat(locale, options).format(date);
  } catch {
    return new Intl.DateTimeFormat('en-SG', options).format(date);
  }
}

export function getRemainingMs(endDate: string, now = Date.now()): number {
  const endTime = new Date(endDate).getTime();
  if (Number.isNaN(endTime)) return 0;
  return Math.max(0, endTime - now);
}

export function getCountdownParts(
  remainingMs: number,
): Record<CountdownUnit, string> {
  const totalSeconds = Math.floor(Math.max(0, remainingMs) / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return {
    days: days.toString().padStart(2, '0'),
    hours: hours.toString().padStart(2, '0'),
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0'),
  };
}

export function formatCountdown(
  remainingMs: number,
  units: CountdownUnit[] = defaultCountdownUnits,
): string {
  const parts = getCountdownParts(remainingMs);
  return units.map((unit) => parts[unit]).join(':');
}

export function shouldShowCountdown(remainingMs: number): boolean {
  return remainingMs <= urgencyCountdownThresholdMs;
}
